module.exports = __webpack_public_path__ + "static/media/headphones.a97fb792.jpg";